// Sichtbares Offline-Banner samt Synchronisierungs-Zaehler (Projektplan
// 10.1). Erscheint global ueber jeder Seite, nicht nur auf dem
// Hauptscreen: Wer offline ist, soll das auch in den Einstellungen sehen.

import { useEffect } from "react";
import { WifiOff } from "lucide-react";
import { useOnlineStatus } from "../lib/online.js";
import { useOutboxGroesse, useOutboxSynchronisieren } from "../lib/outbox.js";

export function OfflineBanner() {
  const online = useOnlineStatus();
  const groesse = useOutboxGroesse();
  const synchronisieren = useOutboxSynchronisieren();

  // Sobald die Verbindung zurueckkommt, sofort versuchen nachzusenden statt
  // auf die naechste eigene Aktion zu warten.
  useEffect(() => {
    if (online) synchronisieren.mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- nur beim Wechsel, nicht bei jeder neuen mutate-Referenz
  }, [online]);

  const wartend = groesse.data ?? 0;
  if (online && wartend === 0) return null;

  return (
    <div className="flex items-center justify-center gap-2 bg-neutral-800 px-3 py-1.5 text-center text-xs font-medium text-white">
      {!online && <WifiOff size={14} />}
      <span>
        {!online
          ? wartend > 0
            ? `Offline – ${wartend} ${wartend === 1 ? "Eintrag wartet" : "Einträge warten"} auf Synchronisierung`
            : "Offline – gespeicherte Daten werden angezeigt"
          : `${wartend} ${wartend === 1 ? "Eintrag wird" : "Einträge werden"} synchronisiert...`}
      </span>
    </div>
  );
}
